import { useState, useEffect, useContext, createContext, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

const AvatarContext = createContext(null);

export function AvatarProvider({ children }) {
  const { user } = useAuth();
  const [avatar, setAvatarState] = useState(null);
  // configured = user has ever made a choice (even "no avatar")
  // null in DB = never set; "" in DB = explicitly no avatar; "slug" = has avatar
  const [configured, setConfigured] = useState(false);

  useEffect(() => {
    if (user) {
      const raw = user.avatar ?? null; // null | "" | "slug"
      setAvatarState(raw || null);     // "" → null for display purposes
      setConfigured(raw !== null);     // null = never set, anything else = configured
    }
  }, [user?.user_id, user?.avatar]); // eslint-disable-line react-hooks/exhaustive-deps -- only these fields are read

  const setAvatar = useCallback(async (slug) => {
    setAvatarState(slug || null);
    setConfigured(true);
    // Send "" for "no avatar" so backend stores "" (not NULL), distinguishing from "never set"
    const apiValue = slug || '';
    try {
      await api.put('/api/me/avatar', { avatar: apiValue });
    } catch (e) {
      // optimistic — silent fail
    }
  }, []);

  return (
    <AvatarContext.Provider value={{ avatar, configured, setAvatar }}>
      {children}
    </AvatarContext.Provider>
  );
}

export function useUserAvatar() {
  return useContext(AvatarContext);
}
